<template>
  <div class="box-back-update">
    <div class="text-desc">{{ $t('BACK_TO_CHOOSE_TYPE') }}<br>{{ $t('DATA_WILL_REMOVE') }}</div>
    <div class="back" id="update" @click="() => toggleBackPopup()">
      <div><p>{{ $t('CONTINUE_EDIT_INFORMATION') }}</p></div>
    </div>
    <a href="/" class="btn-color">{{ $t('BACK_LABEL') }}</a>
  </div>
</template>

<script>
export default {
  name: 'BackPopup',
  props: {
    toggleBackPopup: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
};
</script>

<style scoped>

</style>
